import { Validator } from '@vista-digital/validator';
export const defaultBrowsingConfig = {
    maximumSelectedSites: 5
};
export const browsingConfigValidator = Validator.object({
    maximumSelectedSites: Validator.number({ min: 1 })
});
//# sourceMappingURL=browsing.js.map